<template>
  <el-dialog
      title="主体名称校验"
      width="500px"
      :close-on-click-modal="false"
      :visible.sync="visible">
    <div class="">
      <el-form :model="formData" :rules="rules" ref="dataForm" label-width="77px" label-position="left"
               style="width: 100%">

        <el-form-item label="主体名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入主体名称"
                    style="width: 100%"/>

          <div class="tips">
            提示：注册新公司须与核名通知书一致；新入驻公司须与营业执照一致
          </div>
        </el-form-item>
        <el-button type="primary" @click="onVerifyCompanyName"
                   style="width: 100%;">确定
        </el-button>
      </el-form>

    </div>


  </el-dialog>
</template>

<script>
import {enterpriseCheckExist} from "@/api/api";

export default {
  name: "InApplyNoticeDialog",
  data: function () {
    return {
      visible: false,
      formData: {
        name: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入企业名称', trigger: 'change'},
        ],
      }
    }
  },
  methods: {
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    onVerifyCompanyName() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          enterpriseCheckExist(this.formData.name).then(res => {
            if (!res.data) {
              //	未查询到公司，跳转到填写页
              let inApplyId = res.data
              this.jumpToInApply(this.formData.name)
            } else {
              //	查询到，提示走变更审批
              this.$alert('系统中查询到该企业信息，如果需要变更信息，进点击工商变更申请按钮', '温馨提示', {
                confirmButtonText: '确定',
                callback: action => {
                  // this.visible = false;
                }
              });
            }
          })

        } else {

        }
      })
    },
    jumpToInApply(companyName) {
      if (companyName == null) {
        companyName = '0'
      }
      this.$router.push({
        name: 'InApplyWithInfo',
        params: {
          id: '0',
          companyName: companyName,
        }
      });
      this.visible = false;
    },
  }
}
</script>

<style scoped>
.form-container {
  margin-top: 50px;
  border-radius: 15px;
  border: 1px solid rgba(206, 206, 206, 1);
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 13px 17px 0px rgba(0, 0, 0, 0.1);
  width: 60%;
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}
</style>
